<template>
  <div class="content" style="text-align: left">
    <el-button type="default" style="float: right;color: #409eff;border-color: #409eff;" @click="addAddress">+新增收货地址
    </el-button>
    <el-table style="margin-top: 20px;width: 100%;" :data="addressList" v-loading="loading">
      <el-table-column width="60px" prop="Name" label="姓名"></el-table-column>
      <el-table-column width="120px" prop="Phone" label="电话"></el-table-column>
      <!-- <el-table-column width="66px" prop="Provice" label="省份"></el-table-column>
      <el-table-column width="66px" prop="City" label="城市"></el-table-column>
      <el-table-column width="66px" prop="Area" label="区域"></el-table-column> -->
      <el-table-column label="详细地址">
        <template slot-scope="scope">
          {{scope.row.Provice+scope.row.City+scope.row.Area+ scope.row.Detail}}
        </template>
      </el-table-column>
      <el-table-column width="120px" label="是否默认">
        <template slot-scope="scope">
          {{scope.row.IsDefault == 1 ? '是' : '否'}}
        </template>
      </el-table-column>
      <el-table-column width="150px" label="操作">
        <template slot-scope="scope">
          <div style="display:flex">
            <el-button type="text" class="default" style="color:#68c18d" size="small" @click="handleClick(scope.row)">
              设为默认</el-button>
            <el-button type="text" class="edit" style="color:#86b6ff" size="small" @click="handleedit(scope.row)">编辑
            </el-button>
            <el-button type="text" class="delete" style="color:#e27c7a" size="small" @click="handledelete(scope.row)">删除
            </el-button>
          </div>

        </template>
      </el-table-column>

    </el-table>
    <el-dialog class="payDialog" width="500px" top="25vh" :title="isedit ? '编辑收货地址' : '新增收货地址' " :visible.sync="
      showAddress" :close-on-click-modal="false" @close="closeModel">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="收货人">
          <el-input v-model="form.Name"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="form.Phone"></el-input>
        </el-form-item>
        <el-form-item label="省市区">
          <el-cascader size="large" style="width:380px" filterable clearable :options="options"
            v-model="selectedOptions" @change="handleChange">
          </el-cascader>
        </el-form-item>

        <el-form-item label="详细地址">
          <el-input v-model="form.Detail"></el-input>
        </el-form-item>
        <el-form-item label="智能填写">
          <div style="position: relative">
            <el-input placeholder="粘贴或输入一整段地址信息，点击智能填写识别姓名、电话和地址例如：张三,13888888888,深圳市罗湖区国贸大厦" :autosize="{ minRows: 6}"
              type="textarea" v-model="form.smartaddress">
            </el-input>
            <el-link style="position: absolute;right: 10px;bottom: 0px" bottom="false" type="primary" @click="smart">
              智能填写
            </el-link>
            <el-link type="default" style="position: absolute;right: 90px;bottom: 0px" @click="reset">清空</el-link>
          </div>



        </el-form-item>
        <el-form-item label="是否默认">
          <el-switch v-model="form.IsDefault"></el-switch>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-if="!isedit" @click="onSubmit">立即创建</el-button>
          <el-button type="primary" v-else @click="editform">立即修改</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import {
    regionData,
    codeToText,
    pcaTextArr,
    pcTextArr
  } from 'element-china-area-data'

  // import AddressParse, {
  //   AREA,
  //   Utils
  // } from 'address-parse';
  export default {
    data() {
      return {
        options: pcaTextArr,
        options1: pcTextArr,
        selectedOptions: [],
        addressList: [],
        loading: false,
        showAddress: false,
        form: {
          Name: '',
          Phone: '',
          Provice: '',
          City: '',
          Area: '',
          Detail: '',
          IsDefault: '',
          smartaddress: '',
        },
        isedit: false,
      }
    },
    created() {
      this.getAddressList()
    },
    methods: {
      smart() {
        debugger
        console.log('用户输入的信息内容', this.form.smartaddress);
        /**
         * AddressParse.parse(this.addruleForm.intelligenceaddress) //使用组件中的parse方法接收用户的信息 ,返回截取到的对应 姓名 电话 和 地址信息
         * result : 此返回中值地址的信息 只包含了 区的id ,如果实在PC端的话,省市区三级联动需要拿取到 省id 市id 区id 否则不能联动下拉找不到
         * */
        const result = AddressParse.parse(this.form.smartaddress);
        /**
         * Utils.getTargetAreaListByCode 拿取区对应的 父级 市id 和 爷爷级 省id
         */

        console.log('result', result)
        this.form.Provice = result[0].province
        this.form.City = result[0].city
        this.form.Area = result[0].area
        this.form.Detail = result[0].details
        this.form.Name = result[0].name
        this.form.Phone = result[0].mobile
        this.selectedOptions = [this.form.Provice, this.form.City, this.form.Area]
        this.reset()
      },
      reset() {
        this.form.smartaddress = ''
      },
      handleChange() {
        this.form.Provice = ''
        this.form.City = ''
        this.form.Area = ''
        for (let i = 0; i < this.selectedOptions.length; i++) {
          if (i === 0) {
            this.form.Provice = this.selectedOptions[i]
          }
          if (i === 1) {
            this.form.City = this.selectedOptions[i]
          }
          if (i === 2) {
            this.form.Area = this.selectedOptions[i]
          }
        }
      },
      getAddressList() {
        this.loading = true
        this.$api.GetAddressList().then(res => {
          if (res.data.status == 200) {
            this.loading = false
            this.addressList = res.data.data
          } else {
            this.$message.error(res.data.message)
            this.loading = false
          }

        })
      },
      addAddress() {
        this.showAddress = true;
        this.isedit = false;
        this.clearform()
      },
      closeModel() {
        this.showAddress = false
        this.clearform()
      },
      onSubmit() {
        this.$api.AddAddress({
          Name: this.form.Name,
          Phone: this.form.Phone,
          Provice: this.form.Provice,
          City: this.form.City,
          Area: this.form.Area,
          Detail: this.form.Detail,
          Id: 0,
          IsDefault: this.form.IsDefault ? 1 : 0
        }).then(res => {
          console.log(res)
          if (res.data.status == 200) {
            this.$message({
              message: res.data.message,
              type: 'success'
            });
            this.showAddress = false;
            this.getAddressList();
          } else {
            this.$message({
              message: res.data.message,
              type: 'error'
            })
            this.showAddress = false
          }
        })
        this.showAddress = false
      },
      handleedit(row) {

        debugger
        this.showAddress = true
        this.isedit = true
        this.form = {
          Name: row.Name,
          Phone: row.Phone,
          Provice: row.Provice,
          City: row.City,
          Area: row.Area,
          Detail: row.Detail,
          IsDefault: row.IsDefault == 1 ? true : false,
          Id: row.Id
        }
        this.selectedOptions = [row.Provice, row.City, row.Area]
      },
      editform(Id) {
        var param = {
          ...this.form
        }
        param.IsDefault = this.form.IsDefault ? 1 : 0

        var that = this
        this.$api.EditAddressDetail(param).then(res => {
          console.log(res)
          if (res.data.status == 200) {
            this.$message({
              message: res.data.message,
              type: 'success'
            })
            that.clearform()
            that.showAddress = false;
            that.getAddressList();

          } else {
            this.$message({
              message: res.data.message,
              type: 'error'
            })
          }
        })
      },
      clearform() {
        this.form = {
          Name: '',
          Phone: '',
          Provice: '',
          City: '',
          Area: '',
          Detail: '',
          IsDefault: ''
        }
        this.selectedOptions = []
      },
      handledelete(row) {
        var that = this;
        this.$confirm('此操作将永久删除该地址, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.DelAddress({
            Id: row.Id
          }).then(res => {
            console.log(res)
            if (res.data.status == 200) {
              this.$message({
                message: res.data.message,
                type: 'success'
              })
              that.getAddressList();
            } else {
              this.$message({
                message: res.data.message,
                type: 'error'
              })
            }

          })
        }).catch(() => {

        })
      },
      handleClick(row) {
        var that = this
        this.$api.SetDefaultAddress({
          Id: row.Id
        }).then(res => {
          console.log(res)
          if (res.data.status == 200) {
            this.$message({
              message: res.data.message,
              type: 'success'
            })
            that.getAddressList();
          } else {
            this.$message({
              message: res.data.message,
              type: 'error'
            })
          }
        })
      }
    }
  }

</script>

<style lang="less" scoped>
  .default {
    color: #46cf7f;
  }

  .edit {
    color: #86b6ff;
  }

  .delete {
    color: #e27c7a;
  }

</style>



// WEBPACK FOOTER //
// src/page/personcenter/addressinfo.vue